import React from 'react';
import ReactDOM from 'react-dom';
import { createGlobalStyle, ThemeProvider } from 'styled-components';
import App from './App';
import { observe } from './components/Game/Game';
import { GameStatus } from './components/Game/constants';
import theme from './theme/default';
import PlayerNamesProvider from './components/StatusPanel/PlayerNames/PlayerNamesProvider';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
  }
`;

observe(
  (
    tokenPositions,
    diceNumber,
    names,
    move,
    changes,
    gameStatus,
    playerSelection,
    activePlayer,
    stateChangeId,
  ) => {
    let result;
    switch (gameStatus) {
      case GameStatus.LOADING:
        result = (
          <div>
            <h2>Loading</h2>
            <h6>Websocket is loading!</h6>
          </div>
        );
        break;
      case GameStatus.ERROR:
        result = (
          <div>
            <h2>Error</h2>
            <h6>Websocket could not be loaded!</h6>
          </div>
        );
        break;
      case GameStatus.OK:
        result = (
          <React.StrictMode>
            <GlobalStyle />
            <ThemeProvider theme={theme}>
              <PlayerNamesProvider names={names}>
                <App
                  tokenPositions={tokenPositions}
                  diceNumber={diceNumber}
                  move={move}
                  changes={changes}
                  playerSelection={playerSelection}
                  activePlayer={activePlayer}
                  stateChangeId={stateChangeId}
                />
              </PlayerNamesProvider>
            </ThemeProvider>
          </React.StrictMode>
        );
        break;
      default:
        result = (
          <div>
            <h2>Loading</h2>
            <h6>Websocket is loading!</h6>
          </div>
        );
    }
    ReactDOM.render(result, document.getElementById('root'));
  },
);
